module.exports = __webpack_public_path__ + "static/img/x2.82051b1f.png";